export const CompetitionFields = Object.freeze({
  name: "name",
  start_date: "start_date",
  start_date_small: "start_date_small",
  zipcode: "zipcode",
  city: "city",
  department: "department",
});

export const CompetitionFieldsLabels = Object.freeze({
  [CompetitionFields.name]: "Nom",
  [CompetitionFields.start_date]: "Date",
  [CompetitionFields.start_date_small]: "Date",
  [CompetitionFields.zipcode]: "Code postal",
  [CompetitionFields.city]: "Ville",
  [CompetitionFields.department]: "Département",
});
